
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";
import { profileFieldText, profileSectionCard } from "../../detail/common/ProfileSection";
import FieldExpertise from "./FieldExpertise";
import FieldLocation from "./FieldLocation";
import FieldStudy from "./FieldStudy";
import FieldTest from "./FieldTest";

function initialField(value) {
	return profileFieldText(value) || value || "";
}

export default function Form({ profile, doctor, isDesktop }) {
	const navigate = useNavigate();
	const [study, setStudy] = useState(initialField(doctor?.study));
	const [location, setLocation] = useState(initialField(doctor?.location));
	const [test, setTest] = useState(doctor?.test ?? null);
	const [expertiseIds, setExpertiseIds] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const handleStudyChange = (e) => {
		setStudy(e.target.value);
	};

	const handleLocationChange = (e) => {
		setLocation(e.target.value);
	};

	const handleTestChange = (file) => {
		setTest(file);
	};

	const handleExpertiseChange = (ids) => {
		setExpertiseIds(ids);
	};

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.doctorEdit({
			token: LoginHelper.getToken(),
			study: study,
			location: location,
			test_file: test,
			expertise_ids: JSON.stringify(expertiseIds),
		})
			.then((result) => {
				setIsLoading(false);
				navigate("/profile/" + result.id + "/");
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	};

	return (
		<div className={[profileSectionCard, "flex flex-col gap-5"].join(" ")}>
			<h1 className="font-Vazir-700 text-[16px] text-darkBlue text-center pb-2 border-b border-[#E2E8F0]">
				ویرایش درمانگر
			</h1>
			<FieldStudy study={study} onChange={handleStudyChange} />
			<FieldLocation location={location} onChange={handleLocationChange} />
			<FieldTest test={test} onChange={handleTestChange} />
			<FieldExpertise profile={profile} onChange={handleExpertiseChange} isDesktop={isDesktop} />
			<div className="flex flex-col items-stretch gap-2 pt-2 -mx-4 sm:-mx-5 -mb-4 sm:-mb-5">
				<div className="w-full min-h-[56px] rounded-b-xl overflow-hidden shadow-[0_2px_10px_rgba(255,105,75,0.3)]">
					<Button
						onClick={() => {
							handleSubmit();
						}}
						label="ذخیره تغییرات"
						isLoading={isLoading}
						labelClassName="font-Vazir-700 text-[16px]"
					/>
				</div>
				{errorMessage ? (
					<p className="text-center font-Vazir-400 text-[14px] text-error px-4 pb-2">
						{errorMessage}
					</p>
				) : null}
			</div>
		</div>
	);
}
